export const GOOGLE_DRIVE_DYNAMIC_SUGGESTIONS: Array<(query: string) => string> = [
	(query) => `Show files about "${query}"`,
	(query) => `Recent files related to "${query}"`,
	(query) => `Show "${query}" files`,
	(query) => `"${query}" files`,
	(query) => `My "${query}" files from this week`,
	(query) => `My recent "${query}" files`,
	(query) => `List my "${query}" files`,
	(query) => `"${query}" files from this year`,
	(query) => `Show Google docs about "${query}"`,
	(query) => `Google docs related to "${query}"`,
	(query) => `"${query}" Google docs`,
	(query) => `My "${query}" Google docs`,
];
